import { React, Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "../index.js";
import { devLog } from "utils/devLog";
export default function WelcomeModal(props) {
  const { t } = useTranslation();

  useEffect(() => {
    devLog("WelcomeModal");
  }, []);

  return (
    <>
      <Dialog
        config={true}
        title={"DialogHeader"}
        message={
          <Fragment>
            <p>{t("description.StartingDialog1")}</p>
            <ul>
              <li>{t("description.StartingList1")}</li>
              <li>{t("description.StartingList2")}</li>
              <li>{t("description.StartingList3")}</li>
              <li>{t("description.StartingList4")}</li>
              <li>{t("description.StartingList5")}</li>
            </ul>
          </Fragment>
        }
        onClose={props.onClose}
        buttonTitle={"Start"}
      />
    </>
  );
}
